import React, { useEffect, useState, useContext, useRef } from "react";
import { AppContext } from "../../../store/AppContext";
import _, { template } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faSlash, faSync } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { markAsCloseOrders, reprocessOrders } from "../services/OrderService";
import { SalesOrderGridModel } from "../models";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { actionBodyTemplate, actionBodyTemplateTwo, datePlacedBodyTemplate, emptyMessageTemplate, logoBody, statusBodyTemplate, statusItemTemplate } from "../GridBodyTemplates";
// import { Subscription } from "rxjs";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { PaginatorTemplate } from "primereact/paginator";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import moment from "moment";


interface IOrderGridErrorComponentProps {
    loading: boolean;
    orderData: SalesOrderGridModel[];
    isNextDisabled: boolean;
    isPrevDisabled: boolean;
    selectedConnector: string,
    lazyParams: any;  // Consider creating a proper type for this
    setLazyParams: (params: any) => void;
    clearPaginationRecord: () => void;
}

const filterStatuses = [
    /*'ExportComplete', */'NotProcessed', 'ImportFailed', 'ExportFailed', 'ExportStart' /*'Imported'*/
];

const OrderGridErrorComponent: React.FC<IOrderGridErrorComponentProps> = ({
    loading,
    orderData: salesOrderData,
    selectedConnector,
    isNextDisabled,
    isPrevDisabled,
    lazyParams,
    setLazyParams,
    clearPaginationRecord }) => {
    let { State, Dispatch } = useContext(AppContext);
    const [selectedOrders, setSelectedOrders] = useState<Array<SalesOrderGridModel>>();
    // const [salesOrderData, setSalesOrderData] = useState<SalesOrderGridModel>(orderData ?? []);
    const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
    const dt = useRef<DataTable>(null);
    const [reprocessLoading, setReprocessLoading] = useState<boolean>(false);
    const [reprocessLoadingSpin, setReprocessLoadingSpin] = useState<boolean>(false);
    const [reExportLoadingSpin, setReExportLoadingSpin] = useState<boolean>(false);
    const [markCloseOrderLoadingSpin, setMarkCloseOrderLoadingSpin] = useState<boolean>(false);
    const [isCloseOrderDialogOpen, setIsCloseOrderDialogOpen] = useState<boolean>(false);
    // 1. Add state for each filter
    const [filters, setFilters] = useState({ netoOrderId: '', netoCustomer: '', netoOrderStatus: '', datePlaced: '' });

    useEffect(() => {
        if (salesOrderData) selectedStatusOnPageLoad()
    }, [salesOrderData])

    const reprocessing = async (isForced?: boolean) => {
        setReprocessLoading(true);
        isForced ? setReExportLoadingSpin(true) : setReprocessLoadingSpin(true);
        const reprocessOrderRequestResult = await reprocessOrders(State.currentUser.currentUserId, selectedConnector, selectedOrders, isForced);
        if (reprocessOrderRequestResult) {
            Dispatch({ Type: "SET_REQUEST_STATUS", Payload: { isSucceed: true, message: "Orders exported from Maropost And MYOB in progress" } });
        }
        else {
            Dispatch({ Type: "SET_REQUEST_STATUS", Payload: { isSucceed: false, message: "Some Error occurred! while Re-processing!" } });
        }
        setReprocessLoading(false);
        setReprocessLoadingSpin(false);
        setReExportLoadingSpin(false);
    }

    const reset = () => {
        dt.current?.reset();
        setSelectedStatus("");
        setFilters({ netoOrderId: '', netoCustomer: '', netoOrderStatus: '', datePlaced: '' });
    }

    const onStatusFilterChange = (event: any) => {
        dt.current?.filter(event.value, 'status.orderStatus', 'equals');
        setSelectedStatus(event?.value);
    }

    const selectedStatusOnPageLoad = () => {
        const isFailedOrdersExist = salesOrderData?.some(order => order?.status?.orderStatus === "ExportFailed");
        if (isFailedOrdersExist) {
            const selectedStatus: string = "ExportFailed"
            dt.current?.filter(selectedStatus, 'status.orderStatus', 'equals');
            setSelectedStatus(selectedStatus);
        } else {
            setSelectedStatus(null);
        }
    };

    const renderStatusFilter = () => {
        return (
            <Dropdown style={{ width: '100%' }}
                value={selectedStatus}
                options={filterStatuses}
                onChange={onStatusFilterChange}
                itemTemplate={statusItemTemplate}
                showClear
                placeholder="Select a Status"
                className="p-column-filter" />
        );
    }

    const statusFilterElement = renderStatusFilter();

    // 2. Create filter change handlers for each column
    const onNetoOrderIdFilterChange = (event: any) => {
        dt.current?.filter(event?.target?.value, 'netoOrderId', 'contains');
        setFilters(prev => ({ ...prev, netoOrderId: event?.target?.value }));
    };

    const onNetoCustomerFilterChange = (event: any) => {
        dt.current?.filter(event?.target?.value, 'netoCustomer', 'contains');
        setFilters(prev => ({ ...prev, netoCustomer: event?.target?.value }));
    };

    const onNetoOrderStatusFilterChange = (event: any) => {
        dt.current?.filter(event?.target?.value, 'netoOrderStatus', 'contains');
        setFilters(prev => ({ ...prev, netoOrderStatus: event?.target?.value }));
    };

    const onDatePlacedFilterChange = (date: any) => {
        dt.current?.filter(date, 'datePlaced', 'contains');
        setFilters(prev => ({ ...prev, datePlaced: date }));
    };

    const netoOrderIdFilterElement = (
        <div style={{ width: '100%' }}>
            <InputText
                value={filters?.netoOrderId}
                onChange={onNetoOrderIdFilterChange}
                placeholder="Search Order ID"
                className="p-column-filter"
            />
        </div>
    );

    const netoCustomerFilterElement = (
        <div style={{ width: '100%' }}>
            <InputText
                value={filters.netoCustomer}
                onChange={onNetoCustomerFilterChange}
                placeholder="Search Customer"
                className="p-column-filter"
            />
        </div>
    );

    const netoOrderStatusFilterElement = (
        <div style={{ width: '100%' }}>
            <InputText
                value={filters?.netoOrderStatus}
                onChange={onNetoOrderStatusFilterChange}
                placeholder="Search Status"
                className="p-column-filter"
            />
        </div>
    );

    const datePlacedFilterElement = (
        <div style={{ width: '100%' }}>
            <Calendar
                readOnlyInput
                value={new Date(filters?.datePlaced)}
                onChange={(event) => onDatePlacedFilterChange(moment(event?.value?.toString())?.format('DD MMM YYYY'))}
                placeholder="Search" dateFormat="dd-mm-yy" className="p-column-filter" style={{ width: '150px' }} />
        </div>
    );


    const markAsClose = async () => {
        setIsCloseOrderDialogOpen(false);
        setReprocessLoading(true);
        setMarkCloseOrderLoadingSpin(true)
        // const reprocessOrderRequestResult = await markAsCloseOrders(State?.currentUser?.isAdminUser && localStorage.SelectedIdByAdmin ? localStorage.SelectedIdByAdmin : State.currentUser.currentUserId, selectedConnector, selectedOrders);
        const closeOrderRequestResult = await markAsCloseOrders(State?.currentUser?.isAdminUser && localStorage.SelectedIdByAdmin ? localStorage.SelectedIdByAdmin : State.currentUser.currentUserId, selectedConnector, selectedOrders);
        if (closeOrderRequestResult) {
            Dispatch({ Type: "SET_REQUEST_STATUS", Payload: { isSucceed: true, message: "Orders closed in the connector log" } });
        }
        else {
            Dispatch({ Type: "SET_REQUEST_STATUS", Payload: { isSucceed: false, message: "Some Error occurred! while force close!" } });
        }
        setReprocessLoading(false);
        setReprocessLoadingSpin(false);
        setReExportLoadingSpin(false);
        setMarkCloseOrderLoadingSpin(false)
    }

    const onPageChange = (mode: string) => {
        if (mode === 'NEXT') {
            setLazyParams({
                ...lazyParams,
                page: lazyParams.page + 1,
                pageMode: 'NEXT'
            });
        } else if (mode === 'PREV') {
            setLazyParams({
                ...lazyParams,
                page: lazyParams.page - 1,
                pageMode: 'PREV'
            });
        }
    }

    const onPageRowsSizeChanged = (size: number) => {
        clearPaginationRecord();
        let params = { ...lazyParams, pageSize: size };
        if (size === 1) {
            params.pageMode = 'ALL';
        } else {
            params.pageMode = '';
        }
        setLazyParams(params);
    }

    const paginator: PaginatorTemplate = {
        'FirstPageLink': '',
        'LastPageLink': '',
        'NextPageLink': (options) => {
            return <Button label="Next" disabled={isNextDisabled} onClick={() => onPageChange('NEXT')} className="p-button-raised p-button-info" />
        },
        'PageLinks': '',
        'PrevPageLink': (options) => {
            return <Button label="Prev" disabled={isPrevDisabled} onClick={() => onPageChange('PREV')} className="p-button-raised p-button-info" />
        },
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options: any) => {
            const dropdownOptions = [
                { label: 15, value: 15 },
                { label: 25, value: 25 },
                { label: 50, value: 50 },
                { label: 100, value: 100 },
                { label: 200, value: 200 },
                { label: 300, value: 300 },
                { label: 400, value: 400 },
                { label: 500, value: 500 }
            ];
            return (
                <>
                    <span className="p-mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Page Size: </span>
                    <Dropdown value={lazyParams?.pageSize} options={dropdownOptions} onChange={(e) => onPageRowsSizeChanged(e?.value)} appendTo={document.body} />
                </>
            );
        },
        'CurrentPageReport': (options: any) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                </span>
            )
        }
    };

    const header = (
        <div className="d-flex justify-content-between">
            <h5 className="text-left">Failed/Not Processed Orders</h5>
            <div className="col-6 text-right">
                <button
                    type="button"
                    className="btn btn-outline-secondary mr-1"
                    disabled={!selectedOrders || !selectedOrders?.length || reprocessLoading}
                    onClick={() => reprocessing(true)}
                >
                    <div className="fa-layers ml-2">
                        <FontAwesomeIcon className="mr-2" icon={faSync} spin={reExportLoadingSpin}
                        />
                    </div>
                    ReExport
                </button>
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    disabled={!selectedOrders || !selectedOrders.length || reprocessLoading}
                    onClick={() => reprocessing()}
                >
                    <div className="fa-layers ml-2">
                        <FontAwesomeIcon className="mr-2" icon={faSync} spin={reprocessLoadingSpin}
                        />
                    </div>
                    ReProcess
                </button>

                {!_.isEmpty(selectedConnector) &&
                    <button
                        type="button"
                        className="btn btn-outline-secondary ml-1 mr-1"
                        disabled={!selectedOrders || !selectedOrders.length || markCloseOrderLoadingSpin}
                        onClick={() => setIsCloseOrderDialogOpen(true)}
                    >
                        <div className="fa-layers ml-2">
                            <FontAwesomeIcon className="mr-2" icon={faSync} spin={markCloseOrderLoadingSpin}
                            />
                        </div>
                        {/* {`Mark ${!selectedOrders || !selectedOrders.length ? "all" : "selected"} orders as close`} */}
                        {`Force Closed`}

                    </button>
                }
                <button
                    type="button"
                    className="btn btn-outline-secondary ml-2"
                    onClick={reset}
                >
                    <div className="fa-layers ml-2">
                        <FontAwesomeIcon className="mr-2" icon={faFilter} />
                        <FontAwesomeIcon className="mr-2" icon={faSlash} />
                    </div>
                    Clear
                </button>
            </div>
        </div>
    );
    const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column header=""></Column>
                <Column header=""></Column>
                <Column header="OrderID" />
                <Column header="Customer" />
                <Column header="Order Status" />
                <Column header="Processed Status" />
                <Column header="Processed Date" />
                <Column header="Action"></Column>
            </Row>
            <Row>
                <Column headerStyle={{ width: '3em' }} />
                <Column headerStyle={{ width: '3em' }} />
                <Column header="Maropost" filter filterMatchMode="contains" filterPlaceholder="Search" field="netoOrderId" filterElement={netoOrderIdFilterElement} />
                <Column header="Maropost" filter filterMatchMode="contains" filterPlaceholder="Search" field="netoCustomer" filterElement={netoCustomerFilterElement} />
                <Column header="Maropost" filter filterMatchMode="contains" filterPlaceholder="Search" /*filterElement={orderStatusFilterElement}*/ field="netoOrderStatus" filterElement={netoOrderStatusFilterElement} />
                <Column header="Status" filter filterMatchMode="contains" filterPlaceholder="Search" sortField="status.orderStatus" field="status.orderStatus" filterElement={statusFilterElement} />
                <Column header="Date" filter filterPlaceholder="Search By Processed Date" filterElement={datePlacedFilterElement} />
                <Column />
            </Row>
        </ColumnGroup>
    );


    return (
        <div className="container-fluid">
            <DataTable
                lazy={loading}
                loading={loading}
                paginator
                paginatorTemplate={paginator}
                first={lazyParams.first}
                rows={lazyParams.pageSize === 1 ? salesOrderData?.length : lazyParams.pageSize}
                filters={lazyParams.filters}
                removableSort
                ref={dt}
                headerColumnGroup={headerGroup}
                value={salesOrderData}
                header={header}
                className="p-mt-6"
                dataKey="number"
                rowHover
                autoLayout
                emptyMessage={emptyMessageTemplate}
                selectionMode="multiple"
                selection={selectedOrders}
                onSelectionChange={(e: any) => setSelectedOrders(e?.value)}
                paginatorClassName="p-jc-end"
                scrollable
                scrollHeight="520px"
                sortField="datePlacedForFilter"
                sortOrder={-1}
                rowClassName={(rowData: any) => {
                    return { 'highlight': rowData.new };
                }}
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                <Column header="" body={() => logoBody()} />
                <Column field="netoOrderId" body={(data) => actionBodyTemplateTwo(selectedConnector, data)} />
                <Column field="netoCustomer" />
                <Column field="netoOrderStatus" />
                <Column field="status.orderStatus" body={statusBodyTemplate} filterElement={statusFilterElement} />
                <Column filterField="datePlaced" field="datePlacedForFilter" body={datePlacedBodyTemplate} />
                <Column body={(data) => actionBodyTemplate(selectedConnector, data)} />
            </DataTable>

            <Dialog header="Force close orders" visible={isCloseOrderDialogOpen} onHide={() => { }} closable={false} draggable={false} breakpoints={{ '960px': '75vw' }} style={{ width: '35vw' }} >
                <p className="">It will mark the orders "Closed" in the connector log.
                    Please ensure to sync payments before running this process
                    The closed orders will not be updated in MYOB
                </p>
                {/* <h6>Do you wish to continue ?</h6> */}
                <div className="d-flex justify-content-between">
                    <h6 className="px-5 mt-3">Do you wish to continue ?</h6>
                    <div className="">
                        <Button label="Yes" className="px-5 m-1 p-button-raised p-button-info" disabled={markCloseOrderLoadingSpin} onClick={() => markAsClose()} />
                        <Button label="No" className="px-5 m-1 p-button-raised p-button-danger" onClick={() => setIsCloseOrderDialogOpen(false)} />
                    </div>
                </div>

            </Dialog>
        </div>
    );
}

export default OrderGridErrorComponent